export default {
	bulkAttach: {
		successMessage: 'Sku has been attached with the selected label completely.',
		errorMessageTitle: 'Unable to attach label',
	},
};
